import { useLogin } from "@/api/app/login/useLogin";
import InputGroup from "@/components/InputGroup";
import Logo from "@/components/Logo/Logo";
import { Button } from "@/components/ui/button";
import useProfile from "@/hooks/useProfile";
import { Login, loginSchema } from "@/schema/app/Login";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { zodResolver } from "@hookform/resolvers/zod";
import { setCookie } from "cookies-next";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function LoginForm() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setProfile } = useProfile();
  const { trigger, error, isMutating } = useLogin({
    onSuccess: (data) => {
      const { token, user } = data.data;
      setCookie("token", token, {
        maxAge: 60 * 60 * 24,
        path: "/",
      });
      setCookie("user", JSON.stringify(user), {
        maxAge: 60 * 60 * 24,
        path: "/",
      });
      setProfile(user);
      navigate("/app/assessment");
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Login>({
    resolver: zodResolver(loginSchema),
  });

  const errorMsg = {
    email: errors.email?.message || error?.errors?.email?.[0],
    password: errors.password?.message || error?.errors?.password?.[0],
  };

  return (
    <div className="w-[400px]">
      <Logo href="/" />

      <div className="mt-2 font-medium text-cool-gray-800">
        {t("login-message")}
      </div>
      <form
        onSubmit={handleSubmit((values) => trigger(values))}
        className="mt-8 flex flex-col gap-6"
      >
        <InputGroup
          type="email"
          label={t("email")}
          error={errorMsg.email}
          register={register("email")}
        />
        <InputGroup
          label={t("password")}
          type="password"
          error={errorMsg.password}
          register={register("password")}
        />
        <Button
          LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
          isLoading={isMutating}
          type="submit"
        >
          {t("login")}
        </Button>
        {/* TODO: change link to dialog */}
        {/* <Link className="text-center font-medium text-cyan-600" to="/">
          {t("forgot-password-message")}
        </Link> */}
      </form>
    </div>
  );
}

export default LoginForm;
